@if (value && (mode$ | async) === 'Read') {
  <vwui-tooltip label="Tekst kopiëren" [offset]="6">
    <span class="group relative inline-block cursor-pointer" (click)="copyToClipboard()">
      <span class="block absolute inset-y-0 -inset-x-3 mx-2 group-hover:bg-neutral-3 group-hover:rounded-sm"></span>
      <span class="relative group-hover:text-dark">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </span>
    </span>
  </vwui-tooltip>
} @else {
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
}


<ng-template #contentTpl><ng-content></ng-content></ng-template>
